(function(){
  if(!customElements.get('mp-slider')){
    customElements.define('mp-slider', class extends HTMLElement{
      connectedCallback(){
        this.track=this.querySelector('[data-track]');
        if(!this.track) return;
        this.prev=this.querySelector('[data-prev]');
        this.next=this.querySelector('[data-next]');
        var self=this;
        var page=function(){
          var s=self.track.querySelector('.mp-slide');
          if(!s) return self.track.clientWidth;
          var gap=parseFloat(getComputedStyle(self.track).columnGap)||16;
          var w=s.getBoundingClientRect().width+gap;
          return w*Math.max(1,Math.floor((self.track.clientWidth+gap)/w));
        };
        this.update=function(){
          var max=self.track.scrollWidth-self.track.clientWidth-2;
          if(self.prev) self.prev.disabled=self.track.scrollLeft<=2;
          if(self.next) self.next.disabled=self.track.scrollLeft>=max;
        };
        if(this.prev) this.prev.addEventListener('click',function(){self.track.scrollBy({left:-page(),behavior:'smooth'});});
        if(this.next) this.next.addEventListener('click',function(){self.track.scrollBy({left:page(),behavior:'smooth'});});
        this.track.addEventListener('scroll',this.update,{passive:true});
        window.addEventListener('resize',this.update);
        this.update();
      }
      disconnectedCallback(){ window.removeEventListener('resize',this.update); }
    });
  }
  /* MyPetiny: muted decorative loop video.
     Fix: no longer stops on devices with "reduce motion" enabled (Windows with
     Animation effects off, macOS/iOS Reduce motion), which left only the poster image.
     It is muted, short and pauses when scrolled out of view. */
  if(!customElements.get('mp-loop-video')){
    customElements.define('mp-loop-video', class extends HTMLElement{
      connectedCallback(){
        var v=this.querySelector('video');
        if(!v) return;
        var len=parseFloat(this.dataset.seconds)||5;
        var start=parseFloat(this.dataset.start)||0;
        v.muted=true; v.defaultMuted=true; v.playsInline=true;
        v.setAttribute('muted',''); v.setAttribute('playsinline','');
        var play=function(){ var p=v.play(); if(p&&p.catch) p.catch(function(){}); };
        var seek=function(){ try{ v.currentTime=start; }catch(e){} };
        if(v.readyState>=1) seek(); else v.addEventListener('loadedmetadata',seek,{once:true});
        v.addEventListener('canplay',play,{once:true});
        v.addEventListener('timeupdate',function(){ if(v.currentTime>=start+len){ seek(); play(); } });
        v.addEventListener('ended',function(){ seek(); play(); });
        var kick=function(){ if(v.paused) play(); };
        ['pointerdown','touchstart','scroll','keydown'].forEach(function(t){ window.addEventListener(t,kick,{once:true,passive:true}); });
        if('IntersectionObserver' in window){
          this.io=new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ play(); } else { v.pause(); } }); },{threshold:.15});
          this.io.observe(this);
        } else { play(); }
      }
      disconnectedCallback(){ if(this.io) this.io.disconnect(); }
    });
  }
})();
